<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-s-tools"></i>商品相关</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">
            <div>
                <ProduceControl></ProduceControl>
            </div>
        </div>
    </div>
</template>

<script>
import ProduceControl from './ProduceControl.vue'
export default {
    name: 'Produce',
    components: {
        ProduceControl
    },
    data: function(){
        return {
            query: {
                projectName: ''  //项目名
            },
        };
    },
    created(){
       
    },
    activated(){
     
    },
    methods: {

    }
}
</script>